import { ArrowLeft } from 'lucide-react';
import LoginByCode from '@/ui/LoginByCode/LoginByCode';
import WaveLogo from '@/creator/components/WaveLogo';

type Props = {
    backLabel: string;
    onBack: () => void;
    onAuthenticated: () => void | Promise<void>;
    onEmailRequested?: (email: string) => void;
};

/**
 * Full-screen OTP takeover for public campaign and invite links. It embeds the
 * production LoginByCode flow in-place so the browser URL and entry-link context
 * stay intact throughout authentication.
 */
const PublicLoginTakeover = ({ backLabel, onBack, onAuthenticated, onEmailRequested }: Props) => (
    <div className="public-login-page">
        <header className="public-login-page__header">
            <WaveLogo compact />
            <button type="button" onClick={onBack}>
                <ArrowLeft size={15} /> <span>{backLabel}</span>
            </button>
        </header>
        <main className="public-login-page__main">
            <section className="public-login-page__card" aria-label="Log in to Wave">
                <LoginByCode
                    title="Log in to Wave"
                    description="Enter your email and, if you have an account, we’ll send you a one-time login code."
                    onAuthenticated={onAuthenticated}
                    onEmailRequested={onEmailRequested}
                />
            </section>
        </main>
    </div>
);

export default PublicLoginTakeover;
